import { mxgraphInstance } from './mxgraphFactory';
/**
 * Layout
 */
export var mxCircleLayout = mxgraphInstance.mxCircleLayout;
export var mxCompactTreeLayout = mxgraphInstance.mxCompactTreeLayout;
export var mxCompositeLayout = mxgraphInstance.mxCompositeLayout;
export var mxEdgeLabelLayout = mxgraphInstance.mxEdgeLabelLayout;
export var mxFastOrganicLayout = mxgraphInstance.mxFastOrganicLayout;
export var mxGraphLayout = mxgraphInstance.mxGraphLayout;
export var mxParallelEdgeLayout = mxgraphInstance.mxParallelEdgeLayout;
export var mxPartitionLayout = mxgraphInstance.mxPartitionLayout;
export var mxRadialTreeLayout = mxgraphInstance.mxRadialTreeLayout;
export var mxStackLayout = mxgraphInstance.mxStackLayout;
/**
* Layout Hierarchical
*/
export var mxHierarchicalLayout = mxgraphInstance.mxHierarchicalLayout;
export var mxSwimlaneLayout = mxgraphInstance.mxSwimlaneLayout;
/**
* Layout Hierarchical Model
*/
export var mxGraphAbstractHierarchyCell = mxgraphInstance.mxGraphAbstractHierarchyCell;
export var mxGraphHierarchyEdge = mxgraphInstance.mxGraphHierarchyEdge;
export var mxGraphHierarchyModel = mxgraphInstance.mxGraphHierarchyModel;
export var mxGraphHierarchyNode = mxgraphInstance.mxGraphHierarchyNode;
export var mxSwimlaneModel = mxgraphInstance.mxSwimlaneModel;
/**
* Layout Hierarchical Stage
*/
export var mxCoordinateAssignment = mxgraphInstance.mxCoordinateAssignment;
export var mxHierarchicalLayoutStage = mxgraphInstance.mxHierarchicalLayoutStage;
export var mxMedianHybridCrossingReduction = mxgraphInstance.mxMedianHybridCrossingReduction;
export var mxMinimumCycleRemover = mxgraphInstance.mxMinimumCycleRemover;
export var mxSwimlaneOrdering = mxgraphInstance.mxSwimlaneOrdering;
//# sourceMappingURL=Layout.js.map